import React from "react";
import ToggleSwitch from "../ToggleSwitch/toggle-switch";
import "./setting-option.css";

const defaultProps = {
  controlType: "toggle",
  description: "This Setting Controls...",
  buttonText: "",
  buttonClass: "",
  defaultValue: "",
  radioOptions: ["opt1", "opt2", "opt3"],
  showDivider: true,
  useConfirmation: false,
  //sample settings for include confirmation modal
  confirmationSettings: {
    id: "id",
    isActive: false,
    header: "header",
    message: "message",
    headerFontSize: 25,
    messageFontSize: 15,
    icon: undefined,
    iconLeft: false,
    textAlign: "left",
    showDivider: true,
    animate: true,
    animationTime: 500,
    bg_opacity: 0.5,
    height: undefined,
    width: undefined,
    includeCheckboxSafety: true,
    safetyText: "Warning...",
    includeDontAskAgain: false,
    dontAskSetting: "",
    confirmText: "Yes",
    confirmClass: "",
    denyText: "Nevermind",
    denyClass: "",
    onDeny: () => {},
    onConfirm: () => {},
    onClickOut: () => {},
  },
  onChange: () => {},
  onClick: () => {},
};

export function SettingOption(props = defaultProps) {
  function RenderSettingControl(controlType) {
    switch (controlType) {
      case "toggle":
        return (
          <ToggleSwitch
            id={props.id + "-control"}
            active={props.defaultValue ?? false}
            useConfirmation={props.useConfirmation}
            confirmationSettings={props.confirmationSettings}
            onActive={() => {
              props.onChange(true);
            }}
            onInActive={() => {
              props.onChange(false);
            }}
          />
        );
      case "button":
        return (
          <button className={`standard-button ${props.buttonClass ?? 'btn-clr'} setting-option-button`} onClick={props.onClick}>
            {props.buttonText}
          </button>
        );
      //To Implement
      //case 'radio':
      default:
        return <input type="checkbox" />;
    }
  }

  return (
    <>
      <div
        className="setting-option-container"
        style={{
          flexDirection: props.controlType === "button" ? "row-reverse" : "row",
          justifyContent: props.controlType === "button" ? "space-between" : "flex-start",
        }}
      >
        <div className="setting-option-control">{RenderSettingControl(props.controlType)}</div>
        <p className="setting-option-text">
          {props.description ??
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique, eum quos. Culpa consequuntur consequatur ullam ipsum dolorum vel in minus perferendis ex sapiente, facere laboriosam. Autem magnam sed ad sit."}
        </p>
      </div>
      {/* Divider */}
      {props.showDivider && <div className="setting-option-divider"></div>}
    </>
  );
}
